export class ServiceMaster {
	ServiceMasterId: number;
	ServiceTypeName: string;
	SegmentName: string;
	SubSegmentName: string;
	Definition: string;
}
